import { render, staticRenderFns } from "./MenuCatList.vue?vue&type=template&id=bbc90ea4&scoped=true&"
import script from "./MenuCatList.vue?vue&type=script&lang=js&"
export * from "./MenuCatList.vue?vue&type=script&lang=js&"
import style0 from "./MenuCatList.vue?vue&type=style&index=0&id=bbc90ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc90ea4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
